// extracted by mini-css-extract-plugin
export var md = "_5o-4";
export var semantic = "_5o-5";
export var sm = "_5o-3";
export var text = "_5o-6";
export var toggleInput = "_5o-0";
export var toggleSwitch = "_5o-1";
export var xs = "_5o-2";